import type { TenantConfig } from '@/types/TenantConfig'

const red = '#D04A3A'
const navy = '#123356'

export const cfbhall: TenantConfig = {
  logo: 'assets/cfbhall/static/logo.png',
  themeOptions: {
    primaryColor: red,
    secondaryColor: red,
    headerBottomBorder: '1px solid #b7b7b7',
    cartHeaderBackgroundColor: navy,
    footerBackgroundColor: red,
    footerTextColor: 'white',
    logoHeight: '140px',
    headerHeight: '150px',
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/cfbhall/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-300px',
        mobile: '-250px',
      },
    },
  },
  i18nOverrides: {
    en: {
      checkoutRoute: {
        title: '',
      },
    },
  },
}
